'use strict';

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JSX modules
import DeliveryOptionIcon from './delivery-option-icon';
import CartItemsChangeEvents from '../../_cart/cart-items-change-events';
import { builderDispatch } from '../ui';

// -----------------------------------------------------------
//  DeliveryOptionsForm
// -----------------------------------------------------------
class DeliveryOptionsForm extends React.PureComponent {
  static propTypes = {
    hideIcon: PropTypes.bool,
    itemId: PropTypes.number,
    options: PropTypes.array.isRequired,
    selectedOption: PropTypes.number.isRequired,
  };

  render() {
    const { options, selectedOption, itemId = '', hideIcon } = this.props;

    return (
      <div className="delivery-options">
        {
          options.map((option) => {
            const id = `delivery-option-${itemId}-${option.key}`;

            return (
              <fieldset
                key={id}
                className="delivery-option form-check available"
                data-type={option.type}>
                <input
                  id={id}
                  checked={selectedOption == option.key}
                  className="form-check-input"
                  type="radio"
                  value={option.key}
                  onChange={() => this.handleChange(option)} />
                <label
                  className="form-check-label"
                  htmlFor={id}>
                  <DeliveryOptionIcon option={option} hideIcon={hideIcon} />
                </label>
              </fieldset>
            );
          })
        }
      </div>
    );
  }

  handleChange({ key: optionId }) {
    builderDispatch.dispatch({
      type: CartItemsChangeEvents.DELIVERY_OPTION_CHANGE,
      optionId,
      itemId: this.props.itemId
    });
  }
};

DeliveryOptionsForm.displayName = 'Delivery Options Form';

export default DeliveryOptionsForm;
